import { Flex, Grid, Text } from '@chakra-ui/react'
import React from 'react'
import './ImageZoom.css'

const Metadata = ({ currentImage }) => {
	return (
		<Grid gap={1} templateColumns="max-content 1fr" alignItems="center" fontSize={"11px"}>
			<Text fontWeight={"400"} lineHeight={"18px"}>image title</Text>
			<Text className='detail'>{currentImage['image_title']}</Text>

			{/* <Text fontWeight={"400"} lineHeight={"18px"}>image description</Text>
			<Text className='detail'>{currentImage['image_description']}</Text> */}

			{/* <Text fontWeight={"400"} lineHeight={"18px"}>SCOPE</Text>
			<Text>{currentImage['scope'] === 0 ? "Private" : "Public"}</Text> */}

			<Text fontWeight={"400"} lineHeight={"18px"}>favourite</Text>
			<Text className='detail'>{currentImage['is_favourite'] ? "Yes" : "No"}</Text>

			<Text fontWeight={"400"} lineHeight={"18px"}>uploaded on</Text>
			<Text className='detail'>{new Date(currentImage['created_at']).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }).replace(/\//g, "-")}</Text>

			<Text fontWeight={"400"} lineHeight={"18px"}>uploaded by</Text>
			<Text className='detail'>{currentImage['created_by']}</Text>

			{currentImage?.parent_path && <><Text fontWeight={"400"} lineHeight={"18px"}>image path</Text>
			<Text className='detail'>{currentImage?.['parent_path']}</Text></>}

			{currentImage?.time_taken && <><Text fontWeight={"400"} lineHeight={"18px"}> tag processing time</Text>
			<Text className='detail'>{currentImage?.['time_taken'] ? `${currentImage.time_taken} sec` : ''}</Text></>}

			{currentImage?.tag_generated_on && <><Text fontWeight={"400"} lineHeight={"18px"}> tag generate on</Text>
			<Text className='detail'>{currentImage?.tag_generated_on && new Date(currentImage['tag_generated_on']).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }).replace(/\//g, "-")}</Text></>}

			{currentImage?.tag_generated_by && <><Text fontWeight={"400"} lineHeight={"18px"}> tag generate by</Text>
			<Text className='detail'>{currentImage?.['tag_generated_by']}</Text></>}

			{currentImage?.['reviewed_on'] && <><Text>reviewed on</Text>
			<Text className='detail'>{currentImage?.reviewed_on && new Date(currentImage['reviewed_on']).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }).replace(/\//g, "-")}</Text></> }

			{currentImage?.reviewed_by && <><Text fontWeight={"400"} lineHeight={"18px"}> review by</Text>
			<Text className='detail'>{currentImage?.['reviewed_by']}</Text></> }
				
		</Grid>
	)
}

export default Metadata
